import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Retrieve the token from storage
    const jwtToken = localStorage.getItem('currentUserToken');
    if (jwtToken) {
      // If we have a token, clone the request to add the authorization header.
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${jwtToken}`
        }
      });
    }
    // Pass the cloned request instead of the original request to the next handle
    return next.handle(request);
  }
}